package com.fantasytenis.shared.data.notifications.repository

import com.fantasytenis.shared.data.notifications.api.NotificationsApi
import com.fantasytenis.shared.domain.notifications.NotificationsRepository
import com.fantasytenis.shared.domain.notifications.entity.NotificationPage

/**
 * Implementation of NotificationsRepository using the API client.
 */
class NotificationsRepositoryImpl(
    private val api: NotificationsApi
) : NotificationsRepository {

    override suspend fun getNotifications(
        limit: Int,
        offset: Int,
        unreadOnly: Boolean
    ): NotificationPage {
        val response = api.getNotifications(limit, offset, unreadOnly)
        if (response.status != 1 || response.data == null) {
            throw Exception(response.error?.message ?: "Failed to fetch notifications")
        }
        return response.data.toPage()
    }

    override suspend fun getUnreadCount(): Int {
        val response = api.getUnreadCount()
        if (response.status != 1 || response.data == null) {
            throw Exception(response.error?.message ?: "Failed to fetch unread count")
        }
        return response.data.count
    }

    override suspend fun markAsRead(notificationId: String): Boolean {
        val response = api.markAsRead(notificationId)
        if (response.status != 1 || response.data == null) {
            throw Exception(response.error?.message ?: "Failed to mark notification as read")
        }
        return response.data.success
    }

    override suspend fun markAllAsRead(): Boolean {
        val response = api.markAllAsRead()
        if (response.status != 1 || response.data == null) {
            throw Exception(response.error?.message ?: "Failed to mark all notifications as read")
        }
        return response.data.success
    }

    override suspend fun deleteNotification(notificationId: String): Boolean {
        val response = api.deleteNotification(notificationId)
        if (response.status != 1 || response.data == null) {
            throw Exception(response.error?.message ?: "Failed to delete notification")
        }
        return response.data.success
    }
}
